import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

const TermsAndConditions = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-black text-white">
      {/* Header */}
      <div className="sticky top-0 bg-black/80 backdrop-blur-sm border-b border-white/10 px-6 py-4 z-10">
        <div className="max-w-4xl mx-auto flex items-center gap-4">
          <Button
            onClick={() => navigate(-1)}
            variant="ghost"
            className="text-white hover:bg-white/10 p-2"
          >
            <ArrowLeft className="w-5 h-5" />
          </Button>
          <h1 className="text-xl font-bold">Términos y Condiciones</h1>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 py-8">
        <div className="prose prose-invert max-w-none space-y-6 text-[#E0E0E0]">
          <div className="text-center mb-8">
            <h2 className="text-2xl font-bold text-white mb-2">
              TÉRMINOS DE SERVICIO — CONTRATO DE ADHESIÓN
            </h2>
            <h3 className="text-xl font-semibold text-white">
              PROGRAMA "MIEMBROS PREMIER"
            </h3>
          </div>

          <p className="text-sm leading-relaxed">
            Los presentes Términos de Servicio — Contrato de Adhesión (los "Términos") regulan de manera integral, exhaustiva y vinculante la relación jurídica entre usted, como usuario (el "Usuario"), e Iván Hidalgo Henaine, por su propio derecho, como titular y operador del programa "Miembros Premier" (el "Operador").
          </p>

          <p className="text-sm leading-relaxed">
            La aceptación electrónica del Usuario (incluyendo: registro, check-out, clic en "Aceptar", uso del QR, o pago) implica consentimiento pleno, obligatorio e irrevocable respecto de estos Términos, los cuales constituyen el único acuerdo aplicable a la prestación del Servicio Miembros Premier.
          </p>

          <section className="space-y-4">
            <h4 className="text-lg font-bold text-white">1. Objeto del Contrato</h4>
            <p className="text-sm leading-relaxed">
              El presente Contrato regula:
            </p>
            <ol className="list-decimal list-inside space-y-2 text-sm leading-relaxed ml-4">
              <li>La contratación y operación de la Membresía Miembros Premier,</li>
              <li>El acceso a la plataforma digital y a la visualización y obtención de los beneficios, descuentos y promociones otorgados por las Marcas Afiliadas,</li>
              <li>El uso de códigos QR dinámicos, herramientas digitales y credenciales del Usuario,</li>
              <li>El comportamiento, responsabilidades y obligaciones del Usuario,</li>
              <li>El procesamiento de pagos mediante Stripe y sus reglas aplicables,</li>
              <li>Las facultades del Operador para suspender, limitar o cancelar el Servicio por cualquier incumplimiento.</li>
            </ol>
            <p className="text-sm leading-relaxed">
              El Usuario reconoce que Miembros Premier no es un proveedor de bienes o servicios, sino un programa que conecta al Usuario con beneficios ofrecidos por terceros independientes (las Marcas Afiliadas).
            </p>
          </section>

          <section className="space-y-4">
            <h4 className="text-lg font-bold text-white">2. Naturaleza del Programa y Limitación de Responsabilidad Comercial</h4>
            <p className="text-sm leading-relaxed">
              Cada beneficio, descuento o promoción:
            </p>
            <ul className="list-disc list-inside space-y-2 text-sm leading-relaxed ml-4">
              <li>Es diseñado, operado y aplicado exclusivamente por cada Marca Afiliada.</li>
              <li>Está sujeto a disponibilidad, vigencia, restricciones comerciales y operativas propias de la Marca.</li>
              <li>Puede ser modificado, suspendido o cancelado sin previo aviso por la Marca Afiliada, salvo por el beneficio permanente del 5% (cinco por ciento).</li>
            </ul>
            <p className="text-sm leading-relaxed">
              En virtud de lo anterior, Miembros Premier no garantiza la permanencia, disponibilidad, calidad, naturaleza, alcance o valor económico de ningún beneficio. La relación de consumo respecto de productos o servicios ocurre siempre entre el Usuario y la Marca Afiliada.
            </p>

            <div className="mt-4">
              <h5 className="text-base font-semibold text-white mb-2">2.1 Información visual, catálogo y mapa del outlet</h5>
              <p className="text-sm leading-relaxed">
                La información mostrada en la plataforma, incluyendo el mapa del outlet, logotipos, ubicación de tiendas o fichas informativas:
              </p>
              <ul className="list-disc list-inside space-y-2 text-sm leading-relaxed ml-4">
                <li>Tiene fines exclusivamente informativos y orientativos.</li>
                <li>Puede estar desactualizada o contener errores.</li>
                <li>No garantiza la existencia de beneficios activos, participación vigente de la tienda, disponibilidad de inventario ni condiciones comerciales específicas.</li>
              </ul>
              <p className="text-sm leading-relaxed mt-2">
                La visualización de una tienda en el mapa no genera derecho alguno a exigir beneficios.
              </p>
            </div>
          </section>

          <section className="space-y-4">
            <h4 className="text-lg font-bold text-white">3. Tarifa, Pago, Renovación y Procesamiento mediante Stripe</h4>
            
            <div>
              <h5 className="text-base font-semibold text-white mb-2">3.1 Tarifa mensual</h5>
              <p className="text-sm leading-relaxed">
                El costo de la membresía es de: <strong>$277.00</strong> (doscientos setenta y siete pesos 00/100 M.N.) mensuales, IVA incluido. No existen tarifas adicionales por parte del Operador salvo que se indiquen expresamente en la plataforma.
              </p>
            </div>

            <div>
              <h5 className="text-base font-semibold text-white mb-2">3.2 Procesamiento de pagos a través de Stripe</h5>
              <p className="text-sm leading-relaxed">
                El Usuario acepta que:
              </p>
              <ul className="list-disc list-inside space-y-2 text-sm leading-relaxed ml-4">
                <li>Stripe es el único procesador de pagos autorizado.</li>
                <li>Todos los pagos, renovaciones, contracargos, disputas, verificaciones y validaciones se rigen exclusivamente por los Términos y Condiciones de Stripe.</li>
                <li>Miembros Premier no almacena, procesa ni controla la información bancaria del Usuario.</li>
                <li>El Usuario debe resolver directamente con Stripe cualquier queja o disputa sobre el cargo.</li>
              </ul>
              <p className="text-sm leading-relaxed mt-2">
                El Usuario autoriza un cargo recurrente mensual automático e irrevocable mientras no cancele conforme a este Contrato.
              </p>
            </div>

            <div>
              <h5 className="text-base font-semibold text-white mb-2">3.3 Renovación automática</h5>
              <p className="text-sm leading-relaxed">
                La Membresía se renueva mensualmente de manera automática. El Usuario será responsable de mantener actualizado su método de pago. La falta de fondos no exime de la obligación de pago.
              </p>
            </div>
          </section>

          <section className="space-y-4">
            <h4 className="text-lg font-bold text-white">4. Acceso del Dominio Digital, Acceso Privado y Licencia Limitada</h4>
            
            <div>
              <h5 className="text-base font-semibold text-white mb-2">4.1. Naturaleza del acceso</h5>
              <p className="text-sm leading-relaxed">
                El acceso al Servicio Miembros Premier se realiza exclusivamente a través del dominio privado designado por el Operador, protegido mediante credenciales personales (usuario y contraseña). Dicho acceso constituye una licencia limitada, revocable, no exclusiva y estrictamente personal para consultar y utilizar las funciones del Programa mientras la Membresía se encuentre activa y al corriente de pago.
              </p>
              <p className="text-sm leading-relaxed mt-2">
                La licencia otorgada no transfiere propiedad ni derechos sobre el dominio, el código fuente, diseño, arquitectura, bases de datos, elementos visuales, funcionalidades o cualquier componente intelectual o tecnológico del sistema.
              </p>
            </div>

            <div>
              <h5 className="text-base font-semibold text-white mb-2">4.2.</h5>
              <p className="text-sm leading-relaxed">
                El Usuario se obliga a mantener su usuario y contraseña de forma confidencial y segura. Cualquier acceso realizado con dichas credenciales se considerará efectuado por el Usuario titular, salvo prueba plena en contrario. Queda prohibido permitir el acceso al dominio a terceros, acompañantes, familiares o cualquier persona distinta al Usuario titular.
              </p>
            </div>

            <div>
              <h5 className="text-base font-semibold text-white mb-2">4.3.</h5>
              <p className="text-sm leading-relaxed">
                La plataforma digital:
              </p>
              <ul className="list-disc list-inside space-y-2 text-sm leading-relaxed ml-4">
                <li>Se presta "tal cual" y "según disponibilidad",</li>
                <li>Puede experimentar interrupciones, fallas, mantenimiento o actualizaciones,</li>
                <li>Puede ser modificada, ajustada o suspendida sin previo aviso,</li>
                <li>Depende de servicios externos (internet, servidores, navegadores, Stripe), ajenos al control del Operador.</li>
              </ul>
              <p className="text-sm leading-relaxed mt-2">
                El Operador no garantiza:
              </p>
              <ul className="list-disc list-inside space-y-2 text-sm leading-relaxed ml-4">
                <li>Acceso ininterrumpido,</li>
                <li>Compatibilidad universal con todo dispositivo,</li>
                <li>Ausencia de errores,</li>
                <li>Funcionamiento continuo o libre de fallas técnicas.</li>
              </ul>
              <p className="text-sm leading-relaxed mt-2">
                El Usuario es responsable de contar con conexión a internet, equipo funcional y navegador actualizado.
              </p>
            </div>

            <div>
              <h5 className="text-base font-semibold text-white mb-2">4.4.</h5>
              <p className="text-sm leading-relaxed">
                Queda estrictamente prohibido al Usuario:
              </p>
              <ul className="list-disc list-inside space-y-2 text-sm leading-relaxed ml-4">
                <li>Realizar ingeniería inversa, descompilación o extracción de código.</li>
                <li>Interferir, manipular o intentar alterar el funcionamiento del dominio.</li>
                <li>Crear accesos múltiples, duplicados o no autorizados.</li>
                <li>Utilizar bots, scripts, automatización, espejeo, scraping, proxys anónimos o VPN para alterar la operación del sistema.</li>
                <li>Reproducir, copiar o intentar congelar el funcionamiento del QR dinámico.</li>
                <li>Acceder al sistema desde dispositivos de terceros con el fin de ceder el beneficio.</li>
              </ul>
            </div>

            <div>
              <h5 className="text-base font-semibold text-white mb-2">4.5.</h5>
              <p className="text-sm leading-relaxed">
                El Usuario autoriza al Operador a emplear herramientas tecnológicas para:
              </p>
              <ul className="list-disc list-inside space-y-2 text-sm leading-relaxed ml-4">
                <li>Detectar accesos simultáneos,</li>
                <li>Inhabilitar sesiones sospechosas,</li>
                <li>Bloquear temporal o definitivamente la cuenta,</li>
                <li>Invalidar QR en tiempo real si se detecta uso indebido,</li>
                <li>Registrar actividad para fines de seguridad y auditoría interna.</li>
              </ul>
            </div>

            <div>
              <h5 className="text-base font-semibold text-white mb-2">4.6.</h5>
              <p className="text-sm leading-relaxed">
                El Usuario será responsable por cualquier daño, perjuicio o uso indebido derivado del acceso, uso o resguardo negligente de sus credenciales. La violación de esta sección faculta al Operador para:
              </p>
              <ul className="list-disc list-inside space-y-2 text-sm leading-relaxed ml-4">
                <li>Cancelar la Membresía sin reembolso,</li>
                <li>Bloquear permanentemente el acceso,</li>
                <li>Notificar a Marcas Afiliadas,</li>
                <li>Iniciar acciones legales cuando corresponda.</li>
              </ul>
            </div>
          </section>

          <section className="space-y-4">
            <h4 className="text-lg font-bold text-white">5. Cancelación del Servicio</h4>
            
            <div>
              <h5 className="text-base font-semibold text-white mb-2">5.1 Derecho del Usuario a cancelar</h5>
              <p className="text-sm leading-relaxed">
                El Usuario puede cancelar en cualquier momento, sin penalización.
              </p>
              <p className="text-sm leading-relaxed">
                La cancelación se realiza a través de la plataforma en el apartado de "Cuenta".
              </p>
            </div>

            <div>
              <h5 className="text-base font-semibold text-white mb-2">5.2 Efectos de la cancelación</h5>
              <ul className="list-disc list-inside space-y-2 text-sm leading-relaxed ml-4">
                <li>No habrá cargos posteriores.</li>
                <li>No hay reembolsos por el mes ya cobrado.</li>
                <li>El Usuario conservará acceso solo hasta el último día del mes pagado, sin excepción.</li>
                <li>La reactivación requerirá autorizar de nuevo el pago a través del alta mediante Stripe.</li>
              </ul>
            </div>
          </section>

          <section className="space-y-4">
            <h4 className="text-lg font-bold text-white">6. Carácter Personalísimo, Individual y No Transferible</h4>
            <p className="text-sm leading-relaxed">
              La Membresía Miembros Premier es:
            </p>
            <ul className="list-disc list-inside space-y-2 text-sm leading-relaxed ml-4">
              <li>Personal e intransferible,</li>
              <li>De uso exclusivo del Usuario titular,</li>
              <li>No puede ser prestada, vendida, cedida, rentada, compartida o utilizada por terceros, familiares o acompañantes.</li>
            </ul>
            <p className="text-sm leading-relaxed mt-2">
              Cualquier intento de compartir, duplicar, transferir o replicar accesos, beneficios o QR constituye una violación grave y causará:
            </p>
            <ul className="list-disc list-inside space-y-2 text-sm leading-relaxed ml-4">
              <li>Cancelación inmediata de la membresía,</li>
              <li>Pérdida de acceso sin reembolso,</li>
              <li>Bloqueo permanente del Usuario,</li>
              <li>Notificación a las Marcas Afiliadas para negar beneficios en lo futuro.</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h4 className="text-lg font-bold text-white">7. Códigos QR Dinámicos — Reglas, Protección y Uso Obligatorio</h4>
            
            <div>
              <h5 className="text-base font-semibold text-white mb-2">7.1 Naturaleza del QR Dinámico</h5>
              <p className="text-sm leading-relaxed">
                El Usuario accede a sus beneficios mediante un código QR dinámico, considerado información personal y confidencial.
              </p>
              <p className="text-sm leading-relaxed mt-2">
                El QR dinámico:
              </p>
              <ol className="list-decimal list-inside space-y-2 text-sm leading-relaxed ml-4">
                <li>Cambia automáticamente en intervalos aleatorios para impedir captura o duplicación.</li>
                <li>Queda asociado criptográficamente a la identidad del Usuario.</li>
                <li>Solo puede activarse y validarse desde la cuenta del Usuario titular.</li>
                <li>No puede ser compartido ni utilizado por terceros bajo ninguna circunstancia.</li>
              </ol>
              <p className="text-sm leading-relaxed mt-2">
                La expiración del código QR, aun cuando ocurra durante el proceso de validación en tienda, no genera obligación alguna para la Marca Afiliada ni para el Operador de aplicar el beneficio. El Usuario es responsable de contar con un código QR vigente, visible y funcional al momento exacto de la validación.
              </p>
            </div>

            <div>
              <h5 className="text-base font-semibold text-white mb-2">7.2 Prohibiciones absolutas</h5>
              <p className="text-sm leading-relaxed">
                El Usuario tiene estrictamente prohibido:
              </p>
              <ul className="list-disc list-inside space-y-2 text-sm leading-relaxed ml-4">
                <li>Realizar capturas de pantalla del QR y reenviarlas para ser aprovechadas por terceros.</li>
                <li>Permitir a terceros usar su teléfono o su QR.</li>
                <li>Fotografiar, imprimir o reproducir el QR.</li>
                <li>Intentar congelar o alterar el QR dinámico.</li>
                <li>Usar VPN, apps espejo o herramientas que manipulen la visualización del QR.</li>
              </ul>
            </div>

            <div>
              <h5 className="text-base font-semibold text-white mb-2">7.3 Verificación presencial obligatoria</h5>
              <p className="text-sm leading-relaxed">
                Toda Marca Afiliada podrá y deberá:
              </p>
              <ul className="list-disc list-inside space-y-2 text-sm leading-relaxed ml-4">
                <li>Solicitar identificación oficial del Usuario titular,</li>
                <li>Confirmar coincidencia entre QR y titular,</li>
                <li>Negar la aplicación del beneficio cuando el Usuario no esté presente físicamente o existan dudas razonables de su identidad.</li>
              </ul>
              <p className="text-sm leading-relaxed mt-2">
                El Usuario acepta expresamente que sin estar presente, la Marca Afiliada podrá negar el beneficio sin responsabilidad alguna.
              </p>
            </div>
          </section>

          <section className="space-y-4">
            <h4 className="text-lg font-bold text-white">8. Beneficios y Restricciones de las Marcas Afiliadas</h4>
            <p className="text-sm leading-relaxed">
              Los beneficios:
            </p>
            <ul className="list-disc list-inside space-y-2 text-sm leading-relaxed ml-4">
              <li>Se actualizan continuamente,</li>
              <li>Pueden tener horas, productos, zonas o días restringidos,</li>
              <li>Están sujetos a disponibilidad del inventario de la Marca,</li>
              <li>Pueden no ser acumulables con otras promociones,</li>
              <li>Están condicionados a la política comercial de la Marca Afiliada.</li>
            </ul>
            <p className="text-sm leading-relaxed mt-2">
              El Usuario acepta que:
            </p>
            <ol className="list-decimal list-inside space-y-2 text-sm leading-relaxed ml-4">
              <li>Aplican las restricciones publicadas en la plataforma, y</li>
              <li>Aplican también las restricciones adicionales comunicadas directamente en tienda, las cuales prevalecerán en caso de conflicto.</li>
            </ol>
            <p className="text-sm leading-relaxed mt-2">
              Las Marcas Afiliadas tienen la facultad de:
            </p>
            <ul className="list-disc list-inside space-y-2 text-sm leading-relaxed ml-4">
              <li>Suspender beneficios durante eventos, temporadas altas o por saturación,</li>
              <li>Modificar condiciones sin previo aviso,</li>
              <li>Negar beneficios por uso indebido del QR o comportamiento inapropiado del Usuario.</li>
            </ul>
            <p className="text-sm leading-relaxed mt-2">
              El Usuario reconoce y acepta que podrán existir periodos en los que no se muestren beneficios disponibles en la plataforma, sin que ello implique incumplimiento del Servicio ni genere derecho a reembolso, bonificación o compensación alguna.
            </p>
          </section>

          <section className="space-y-4">
            <h4 className="text-lg font-bold text-white">9. Obligaciones del Usuario y Soporte Técnico</h4>
            <p className="text-sm leading-relaxed">
              El Usuario se obliga a:
            </p>
            <ul className="list-disc list-inside space-y-2 text-sm leading-relaxed ml-4">
              <li>Proporcionar información veraz y actualizada.</li>
              <li>Usar el Servicio exclusivamente para fines personales y lícitos.</li>
              <li>Mantener el control de su cuenta, QR y credenciales.</li>
              <li>Respetar al personal del Operador y de las Marcas Afiliadas.</li>
              <li>No vulnerar sistemas, software o herramientas del Operador.</li>
            </ul>
            <p className="text-sm leading-relaxed mt-2">
              El soporte técnico del Operador tiene como finalidad asistir al Usuario en el uso de la plataforma, sin que tenga facultades para modificar, forzar o exigir la aplicación de beneficios por parte de las Marcas Afiliadas.
            </p>
          </section>

          <section className="space-y-4">
            <h4 className="text-lg font-bold text-white">10. Facultades de Miembros Premier</h4>
            <p className="text-sm leading-relaxed">
              El Operador podrá, sin responsabilidad y de manera inmediata:
            </p>
            <ul className="list-disc list-inside space-y-2 text-sm leading-relaxed ml-4">
              <li>Suspender o cancelar membresías por incumplimiento,</li>
              <li>Bloquear cuentas por fraude o uso indebido,</li>
              <li>Reportar intentos de fraude a autoridades,</li>
              <li>Actualizar beneficios, reglas y políticas del Programa,</li>
              <li>Limitar funciones del QR en caso de actividad sospechosa.</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h4 className="text-lg font-bold text-white">11. Limitación de Responsabilidad</h4>
            <p className="text-sm leading-relaxed">
              Miembros Premier:
            </p>
            <ul className="list-disc list-inside space-y-2 text-sm leading-relaxed ml-4">
              <li>No garantiza la continuidad indefinida del Programa ni de los beneficios,</li>
              <li>No garantiza disponibilidad o inventarios de las Marcas Afiliadas,</li>
              <li>No responde por perjuicios indirectos, lucro cesante o daños consecuenciales,</li>
              <li>No responde por fallas técnicas ajenas a su control, incluidas las de Stripe,</li>
              <li>Limita su responsabilidad máxima al monto efectivamente pagado por el Usuario durante los últimos tres meses.</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h4 className="text-lg font-bold text-white">12. Modificaciones</h4>
            <p className="text-sm leading-relaxed">
              El Operador podrá modificar estos Términos, los beneficios, las condiciones y las políticas internas del Programa sin previo aviso. El uso continuo del Servicio implica aceptación automática.
            </p>
          </section>

          <section className="space-y-4">
            <h4 className="text-lg font-bold text-white">13. Jurisdicción y Controversias</h4>
            <p className="text-sm leading-relaxed">
              Las controversias se resolverán mediante:
            </p>
            <ol className="list-decimal list-inside space-y-2 text-sm leading-relaxed ml-4">
              <li>Sistema interno de resolución de Miembros Premier, y</li>
              <li>Tribunales competentes de la Ciudad de Puebla, México, salvo disposición imperativa en contrario.</li>
            </ol>
          </section>

          <section className="space-y-4">
            <h4 className="text-lg font-bold text-white">14. Aceptación del Contrato</h4>
            <p className="text-sm leading-relaxed">
              El Usuario manifiesta su consentimiento pleno al:
            </p>
            <ul className="list-disc list-inside space-y-2 text-sm leading-relaxed ml-4">
              <li>Registrarse,</li>
              <li>Iniciar sesión,</li>
              <li>Pagar mediante Stripe,</li>
              <li>Activar su Membresía,</li>
              <li>Oprimir "Aceptar", "Continuar", "Suscribirme", "Pagar" o botones equivalentes.</li>
            </ul>
            <p className="text-sm leading-relaxed mt-2">
              Esta aceptación tiene efectos legales y obligatorios.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;

